import { render, staticRenderFns } from "./SagliknetIcd10.vue?vue&type=template&id=5f0c3254&"
import script from "./SagliknetIcd10.vue?vue&type=script&lang=js&"
export * from "./SagliknetIcd10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports